function syncRelatedSectionVisibility(wrapper) {
  if (!wrapper) return;

  const section = wrapper.closest('.shopify-section');
  const hasContent = Boolean(wrapper.querySelector('[data-bbs-product-related]'));

  if (section) {
    section.hidden = !hasContent;
  }
}

function initProductRelated(root) {
  if (!root || root.dataset.bbsRelatedInit === 'true') return;

  const viewport = root.querySelector('[data-bbs-related-viewport]');
  const track = root.querySelector('[data-bbs-related-track]');
  const prevBtn = root.querySelector('[data-bbs-related-prev]');
  const nextBtn = root.querySelector('[data-bbs-related-next]');

  if (!viewport || !track) return;

  root.dataset.bbsRelatedInit = 'true';

  const scrollByPage = (direction) => {
    const item = track.querySelector('.bbs-product-related__item');
    if (!item) return;

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const itemWidth = item.getBoundingClientRect().width + gap;
    const visibleCount = Math.max(1, Math.floor(viewport.clientWidth / itemWidth));
    viewport.scrollBy({ left: direction * itemWidth * visibleCount, behavior: 'smooth' });
  };

  const sync = () => {
    const overflow = track.scrollWidth > viewport.clientWidth + 1;
    root.classList.toggle('bbs-product-related--carousel', overflow);

    if (prevBtn) prevBtn.hidden = !overflow;
    if (nextBtn) nextBtn.hidden = !overflow;

    const maxScroll = track.scrollWidth - viewport.clientWidth;
    const left = viewport.scrollLeft;
    if (prevBtn) prevBtn.disabled = left <= 1;
    if (nextBtn) nextBtn.disabled = left >= maxScroll - 1;
  };

  prevBtn?.addEventListener('click', () => scrollByPage(-1));
  nextBtn?.addEventListener('click', () => scrollByPage(1));
  viewport.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  sync();
}

function scanProductRelated(scope = document) {
  scope.querySelectorAll('[data-bbs-product-related]').forEach((root) => {
    initProductRelated(root);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  scanProductRelated();

  document.querySelectorAll('[data-bbs-related-root]').forEach((wrapper) => {
    syncRelatedSectionVisibility(wrapper);

    if (wrapper.querySelector('[data-bbs-product-related]')) return;

    const productId = wrapper.dataset.productId;
    const sectionId = wrapper.dataset.sectionId;
    const url = wrapper.dataset.url;
    if (!productId || !sectionId || !url) return;

    const observer = new IntersectionObserver(
      (entries, io) => {
        if (!entries[0]?.isIntersecting) return;
        io.unobserve(wrapper);

        fetch(`${url}&product_id=${productId}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const fetched = html.querySelector('[data-bbs-related-root]');
            if (!fetched?.innerHTML.trim()) return;

            wrapper.innerHTML = fetched.innerHTML;
            scanProductRelated(wrapper);
            syncRelatedSectionVisibility(wrapper);
          })
          .catch((error) => {
            console.error('BBS related products fetch failed', error);
            syncRelatedSectionVisibility(wrapper);
          });
      },
      { rootMargin: '0px 0px 400px 0px' }
    );

    observer.observe(wrapper);
  });
});

window.BBSInitProductRelated = scanProductRelated;
